import { createPermission } from '@backstage/plugin-permission-common';

export const bugsyAccessPermission = createPermission({
  name: 'bugsy.access',
  attributes: {
    action: 'read',
  },
});

/**
 * Gates the operator surface. Deliberately the same permission name the
 * backend declares (`plugins/bugsy-backend/src/permissions.ts`), so the panel
 * and the route it calls cannot disagree about who may trigger a sync.
 */
export const bugsySyncPermission = createPermission({
  name: 'bugsy.sync',
  attributes: {
    action: 'create',
  },
});
